/**
 * Page Wrapper Component
 *
 * Wrapper component that provides consistent layout for settings pages.
 *
 * @since 1.0.0
 */

import { colors } from '@redfoxwp/core-components/colors';
import { Card } from '@redfoxwp/core-components/components/card';
import { Flex } from '@redfoxwp/core-components/components/flex';
import { TabHeader } from '@redfoxwp/core-components/components/tab-header';

import { SettingsActions } from '../settings-actions';
import type { PageWrapperProps } from './types';

/**
 * Page Wrapper component
 *
 * @since 1.0.0
 *
 * @param props The component props.
 *
 * @return JSX element.
 */
export const PageWrapper = ({ title, children }: PageWrapperProps): JSX.Element => (
  <Flex direction='column' gap='30px' fullWidth>
    <TabHeader title={title} />
    <Card styleProps={{ radius: '10px', background: colors?.white }}>{children}</Card>
    <SettingsActions />
  </Flex>
);
